import MiEquipoCards from "#colaborador/MiEquipo/MiEquipo"
import Tabs from "#common/tabs/Tabs"
import { MODULES } from "#constants/modules"
import PERMISOS from "#constants/perfiles"
import { UseHasPermission } from "#hooks/useHasPermission"
import SavingsFundColaborador from "#savings-fund/pages/SavingsFundColaborador"
import VacationDetail from "#vacation/pages/VacationDetail"
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings"
import AirplaneTicketIcon from "@mui/icons-material/AirplaneTicket"
import ArticleIcon from "@mui/icons-material/Article"
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd"
import BusinessIcon from "@mui/icons-material/Business"
import CheckroomIcon from "@mui/icons-material/Checkroom"
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange"
import GroupsIcon from "@mui/icons-material/Groups"
import LockPersonIcon from "@mui/icons-material/LockPerson"
import SavingsIcon from "@mui/icons-material/Savings"
import { Box } from "@mui/material/"
import { useColaboradorId, useReduxUser } from "app/userSlice"
import Documentos from "Components/Colaboradores/Detail/Documentos"
import CompanyDetails from "Components/Colaboradores/DetalleColaborarComponents/CompanyDetails"
import InventarioRH from "Components/Colaboradores/InventarioRH"
import Prestamos from "Components/Colaboradores/Solicitudes/Prestamos"
import { SolicitudesProvider } from "Components/Colaboradores/Solicitudes/SolicitudesContext"
import MiUniforme from "Components/Colaboradores/Uniforme/MiUniforme"
import Asset from "Components/Inventario/Asset"
import { useMemo, useState } from "react"
import { useReduxColaborador, useSetTab } from "../redux/slice"
import DetalleBaja from "./DetalleBaja"

const ColaboradorDetalleTaps = ({ colaborador, show = true }) => {
	const appColaborador = useColaboradorId()
	const moduleAccess = useReduxUser().moduleAccess
	const hasPermission = UseHasPermission(null, true)
	const colaboradorId = useMemo(() => colaborador.id, [colaborador])
	const { tab } = useReduxColaborador()
	const is_rh = hasPermission(PERMISOS.RH_ALL)
	const is_sistemas = hasPermission(PERMISOS.SYSTEM)
	const jefeNominas = hasPermission(PERMISOS.JEFE_NOMINAS)
	const [reloadData, setReloadData] = useState(false)
	const setValue = useSetTab()
	const tabView = is_rh || colaboradorId === appColaborador

	let ShowVacation = hasPermission(
		PERMISOS.GUATEMALA,
		PERMISOS.GRTE_GUAT,
		...PERMISOS.RH_ALL,
	)

	let ShowTeam = hasPermission(
		...PERMISOS.RH_ALL,
		...PERMISOS.GRTE_ALL,
		PERMISOS.JEFATURA,
		PERMISOS.GUATEMALA,
	)

	let notView = true

	if (
		hasPermission(PERMISOS.GUATEMALA, true) ||
		colaborador?.sociedad_id === 3 ||
		!tabView
	) {
		notView = false
	}

	const taps = useMemo(() => {
		if (!colaboradorId) return []
		const selectTaps = [
			{
				show: true,
				title: "Compañía",
				icon: <BusinessIcon />,
				component: <CompanyDetails />,
				module: "default",
			},
			{
				show: tabView,
				title: "Mis Documentos",
				icon: <ArticleIcon />,
				component: <Documentos colaboradorId={colaboradorId} />,
				module: "default",
			},
		]
		if (!colaborador.no_empleado?.includes("VC")) {
			selectTaps.splice(1, 0, {
				show: tabView,
				title: "Inventario RH",
				icon: <AssignmentIndIcon />,
				component: <InventarioRH dataColaborador={colaborador} />,
				module: "default",
			})

			selectTaps.push(
				...[
					{
						show: notView,
						title: "caja de ahorro",
						icon: <SavingsIcon />,
						component: <SavingsFundColaborador colaborador={colaboradorId} />,
						module: MODULES.CAJA_AHORRO,
					},
					{
						show: notView,
						title: "prestamos",
						icon: <CurrencyExchangeIcon />,
						component: <Prestamos />,
						module: MODULES.PRESTAMOS,
					},
					{
						show: tabView,
						id: "tabUniforme",
						title: "uniforme",
						module: MODULES.UNIFORMES,

						icon: <CheckroomIcon />,
						component: (
							<MiUniforme
								dataColaborador={colaborador}
								setReloadData={setReloadData}
								reloadData={reloadData}
							/>
						),
					},
					{
						show: is_sistemas || tabView,
						id: "responsivas",
						title: "Mis herramientas",
						module: "colaborador_herramientas",

						icon: <AdminPanelSettingsIcon />,
						component: <Asset colaborador={colaborador} />,
					},
					{
						show: ShowTeam && tabView,
						title: "Mi equipo",
						icon: <GroupsIcon />,
						module: "default",
						component: (
							<MiEquipoCards
								colaboradorId={colaboradorId}
								perfilPuestoId={colaborador.perfil_puesto_id}
							/>
						),
					},
					{
						show: ShowVacation,
						title: "Vacaciones",
						icon: <AirplaneTicketIcon />,
						module: "vacaciones",

						component: <VacationDetail colaborador={colaboradorId} />,
					},
				],
			)
		}

		selectTaps.unshift({
			show: !!(colaborador?.fecha_baja || colaborador?.motivo_baja),
			title: "Baja",
			module: "default",
			icon: <LockPersonIcon />,
			component: (
				<DetalleBaja
					colaborador_id={colaboradorId}
					activar={true}
					is_rh={is_rh || jefeNominas}
				/>
			),
		})
		return selectTaps
	}, [
		ShowTeam,
		ShowVacation,
		colaborador,
		colaboradorId,
		is_rh,
		jefeNominas,
		notView,
		reloadData,
		tabView,
	])

	const tapsShow = taps.filter((tap) => {
		return (
			moduleAccess.includes(MODULES.ALL) ||
			moduleAccess.includes(tap.module) ||
			tap.module === "default"
		)
	})

	if (!show) return null
	else
		return (
			<Box>
				<SolicitudesProvider
					colaboradorID={colaboradorId}
					sucursal={colaborador.sucursal}
				>
					<Tabs tabs={tapsShow} {...{ value: tab, setValue }} />
				</SolicitudesProvider>
			</Box>
		)
}

export default ColaboradorDetalleTaps
